// extracted by mini-css-extract-plugin
export default {"diggerCard":"DiggerIcon_diggerCard__Fnprs","imageBox":"DiggerIcon_imageBox__GJoCs","badge":"DiggerIcon_badge__f2BER"};